import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import FormChoice from '../../../components/FormChoice/FormChoice';
import { FORM_CHOICE_COMPONENT_TYPES, FORM_CHOICE_TYPES } from '../../../components/FormChoice/types';
import { vars } from '../../../reactive';
import { increaseFormPage } from '../../../reactive/actions';

const FormPetGender = () => {
  const { t } = useTranslation();
  const type = FORM_CHOICE_TYPES.GENDER;
  const { register, control, reset, setValue } = useForm();
  const newPet = vars.newPet();
  const { registerAs } = FORM_CHOICE_COMPONENT_TYPES[type];
  const title = t(FORM_CHOICE_COMPONENT_TYPES[type]?.title, { petName: newPet.name });
  const data = useWatch({ name: `choice_${registerAs}`, control });

  useEffect(() => {
    if (data) {
      vars.newPet({ ...newPet, gender: data });
      increaseFormPage();
    }
  }, [data]);

  return <FormChoice type={type} formOptions={{ register, reset, setValue }} title={title} />;
};
export default FormPetGender;
